interface handleHallTimeChangeProps {
  startTime: string;
  endTime: string;
  formData: any;
  errorMessage: any;
  setErrorMessage: React.Dispatch<React.SetStateAction<any>>;
  considerOnlyBookingTime?: boolean;
}
interface handlePoojaTimeChangeProps {
  startTime: string;
  endTime: string;
  currentItem: any;
  errorMessage: any;
  duration: number;
  setErrorMessage: React.Dispatch<React.SetStateAction<any>>;
  setButtonDisable: React.Dispatch<React.SetStateAction<any>>;
  isPastDateTimeAllowed?: boolean;
  isStartTimeEvening?: boolean;
  isEndTimeMorning?: boolean;
  considerOnlyBookingTime?: boolean;
}

export const formattedDateYYYYMMDD = (date: string) => {
  const [month, day, year] = date?.split("-");
  return `${year}-${month}-${day}`;
};

export const formattedTime24Hrs = (timeWithMeridiem: string) => {
  const [time, meridiem] = timeWithMeridiem?.split(" ");
  let [hour, minute] = time.split(":");

  if (meridiem?.toLowerCase() === "pm" && parseInt(hour) !== 12) {
    hour = String(parseInt(hour, 10) + 12);
  }

  // Pad single digit hour with a leading zero
  if (hour.length === 1) {
    hour = "0" + hour;
  }

  return `${hour}:${minute}`;
};

export const handleHallTimeChangeSetErrors = (
  props: handleHallTimeChangeProps
) => {
  const {
    startTime,
    endTime,
    formData,
    errorMessage,
    setErrorMessage,
    considerOnlyBookingTime,
  } = props;
  const value = formData.bookingTime;
  const date = new Date();
  const currentTimeHours = date.getHours();
  const currentTimeMin = date.getMinutes();
  const currentTimeInMinutes = currentTimeHours * 60 + currentTimeMin;
  const selectedDate = formData?.date
    ? new Date(formattedDateYYYYMMDD(formData?.date))
    : date;
  const isFutureDateSelected = selectedDate > date;
  // Convert time to 24-hour format based on AM/PM
  const [hours, minutes] = value
    ?.toString()
    ?.split(":")
    ?.map((item: any) => parseInt(item));

  let [selectedHours, selectedMinutes] = [hours, minutes];
  const ampm = value?.toString().slice(-2);
  if (hours === 12 && ampm === "PM") {
    selectedHours = 12; // Keep 12 as is
  } else if (ampm === "PM") {
    selectedHours += 12;
  } else if (hours === 12 && ampm === "AM") {
    selectedHours = 0; // Convert 12:00 AM to 0:00 (midnight)
  }
  const selectedTimeInMinutes = selectedHours * 60 + selectedMinutes;

  if (isFutureDateSelected || currentTimeInMinutes <= selectedTimeInMinutes) {
    const [templeStartHours, templeStartMinutes] = startTime
      ?.split(":")
      .map((item: any) => parseInt(item));
    const [templeEndHours, templeEndMinutes] = endTime
      ?.split(":")
      .map((item: any) => parseInt(item));
    const [HallHours, HallMinutes] = formData.noOfHours
      ?.split(":")
      .map((item: any) => parseInt(item));
    const hallBookingTime = HallHours * 60 + HallMinutes;
    const templeStartingTimeInMinutes =
      templeStartHours * 60 + templeStartMinutes; // temple start time in mins
    const templeClosingTimeInMinutes =
      (templeEndHours + 12) * 60 + templeEndMinutes; // temple end time in mins
    const templeClosingTimeAllowed =
      templeClosingTimeInMinutes - hallBookingTime;
    if (
      selectedTimeInMinutes > templeClosingTimeInMinutes ||
      selectedTimeInMinutes < templeStartingTimeInMinutes
    ) {
      setErrorMessage({
        ...errorMessage,
        bookingTime: `Please select a time between ${startTime} AM and ${endTime} PM.`,
      });
      return;
    }
    if (
      selectedTimeInMinutes <= templeClosingTimeInMinutes &&
      selectedTimeInMinutes > templeClosingTimeAllowed &&
      !considerOnlyBookingTime
    ) {
      setErrorMessage({
        ...errorMessage,
        bookingTime: "Booking time exceeds temple hours.",
      });
    } else {
      setErrorMessage({ ...errorMessage, bookingTime: "" });
    }
  } else {
    setErrorMessage({
      ...errorMessage,
      bookingTime: "Past Time Selection Not Permitted.",
    });
    return;
  }
};

export const handlePoojaTimeChangeSetErrors = (
  props: handlePoojaTimeChangeProps
) => {
  const {
    startTime,
    endTime,
    currentItem,
    errorMessage,
    duration,
    setErrorMessage,
    setButtonDisable,
    isPastDateTimeAllowed,
    considerOnlyBookingTime,
    isStartTimeEvening,
    isEndTimeMorning,
  } = props;
  const value = currentItem.poojaTime;
  const date = new Date();
  const currentTimeHours = date.getHours();
  const currentTimeMin = date.getMinutes();
  const currentTimeInMinutes = currentTimeHours * 60 + currentTimeMin;
  const selectedDate = currentItem?.dateOfPooja
    ? new Date(formattedDateYYYYMMDD(currentItem?.dateOfPooja))
    : date;
  const isFutureDateSelected = selectedDate > date;

  // Convert time to 24-hour format based on AM/PM
  const [hours, minutes] = value?.split(":").map((item: any) => parseInt(item));
  let [selectedHours, selectedMinutes] = [hours, minutes];
  const ampm = value.slice(-2);
  // Handle special case for 12:00 PM
  if (hours === 12 && ampm === "PM") {
    selectedHours = 12; // Keep 12 as is
  } else if (ampm === "PM") {
    selectedHours += 12;
  } else if (hours === 12 && ampm === "AM") {
    selectedHours = 0; // Convert 12:00 AM to 0:00 (midnight)
  }
  const selectedTimeInMinutes = selectedHours * 60 + selectedMinutes;

  if (
    isFutureDateSelected ||
    currentTimeInMinutes <= selectedTimeInMinutes ||
    isPastDateTimeAllowed
  ) {
    const [templeStartHours, templeStartMinutes] = startTime
      ?.split(":")
      .map((item: any) => parseInt(item));
    const [templeEndHours, templeEndMinutes] = endTime
      ?.split(":")
      .map((item: any) => parseInt(item));

    const templeStartingTimeInMinutes =
      (isStartTimeEvening && templeStartHours !== 12
        ? templeStartHours + 12
        : templeStartHours) *
        60 +
      templeStartMinutes; // temple start time in mins
    const templeClosingTimeInMinutes =
      (!isEndTimeMorning && templeEndHours !== 12
        ? templeEndHours + 12
        : templeEndHours) *
        60 +
      templeEndMinutes; // temple end time in mins
    const templeClosingTimeAllowed = templeClosingTimeInMinutes - duration;
    if (
      selectedTimeInMinutes > templeClosingTimeInMinutes ||
      selectedTimeInMinutes < templeStartingTimeInMinutes
    ) {
      setButtonDisable(true);
      setErrorMessage({
        ...errorMessage,
        poojaTime: `Please select a time between ${startTime} ${
          isStartTimeEvening ? "PM" : "AM"
        } and ${endTime} PM.`,
      });
      return;
    }
    if (
      selectedTimeInMinutes <= templeClosingTimeInMinutes &&
      selectedTimeInMinutes > templeClosingTimeAllowed &&
      !considerOnlyBookingTime
    ) {
      setButtonDisable(true);
      setErrorMessage({
        ...errorMessage,
        poojaTime: "Booking time exceeds temple hours.",
      });
    } else {
      setButtonDisable(false);
      setErrorMessage({ ...errorMessage, poojaTime: "" });
    }
  } else {
    setButtonDisable(true);
    setErrorMessage({
      ...errorMessage,
      poojaTime: "Past Time Selection Not Permitted.",
    });
    return;
  }
};

export function getSortedActivities(activities: any) {
  const schedule = activities?.map((eventText: any) => {
    const [time, meridiem, ...nameParts] = eventText?.split(" ");
    return { time: `${time} ${meridiem}`, name: nameParts?.join(" ") };
  });

  schedule?.sort((eventA: any, eventB: any) => {
    const timeA = new Date(
      `2000-01-01 ${formattedTime24Hrs(eventA.time)}`
    )?.getTime();
    const timeB = new Date(
      `2000-01-01 ${formattedTime24Hrs(eventB.time)}`
    )?.getTime();
    return timeA - timeB;
  });

  const templeOpensIndex = schedule?.findIndex(
    (event: any) => event?.name?.trim() === "Temple Opens"
  );
  const templeClosesIndex = schedule?.findIndex(
    (event: any) => event?.name?.trim() === "Temple Closes"
  );

  if (templeOpensIndex !== -1 && templeClosesIndex !== -1) {
    const templeOpensEvent = schedule?.splice(templeOpensIndex, 1)[0];
    const templeClosesEvent = schedule?.splice(templeClosesIndex - 1, 1)[0];
    schedule?.unshift(templeOpensEvent);
    schedule?.push(templeClosesEvent);
  }

  return schedule?.map((event: any) => `${event?.time} ${event?.name}`);
}

export const getTimeWithMeridiem = (activities: string[], keyword: string) => {
  const schedule = activities?.map((eventText: any) => {
    const [time, meridiem, ...nameParts] = eventText?.split(" ");
    return { time: `${time} ${meridiem}`, name: nameParts?.join(" ") };
  });
  const activity = schedule?.find(
    (act) => act?.name?.toLowerCase()?.trim() === keyword
  );
  return activity ? activity?.time : "";
};

export function getStartTimeAndEndTime(activities: any) {
  const schedule = getSortedActivities(activities);

  // Extracting start time from the first activity
  const startTime = schedule[0].split(" ")[0];

  const isStartTimeEvening = schedule[0].split(" ")[1];

  // Extracting end time from the last activity
  const endTime = schedule[activities.length - 1].split(" ")[0];

  const isEndTimeMorning = schedule[activities.length - 1].split(" ")[1];

  return {
    startTime,
    endTime,
    isStartTimeEvening:
      isStartTimeEvening?.toLowerCase() === "pm" ? true : false,
    isEndTimeMorning: isEndTimeMorning?.toLowerCase() === "am" ? true : false,
  };
}

function convertTo24HourFormat(time: string): number {
  const [hourMinute, period] = time.split(" ");
  let [hour, minute] = hourMinute.split(":").map(Number);

  if (period === "PM" && hour !== 12) {
    hour += 12;
  } else if (period === "AM" && hour === 12) {
    hour = 0;
  }

  return hour * 60 + minute; // Return total minutes since midnight
}

export function checkOverlapTimings(
  newStartTime: string,
  newEndTime: string,
  schedules: any
): string | null {
  const newStart = convertTo24HourFormat(newStartTime);
  const newEnd = convertTo24HourFormat(newEndTime);

  const scheduleStartTime = convertTo24HourFormat("06:00 AM");
  const scheduleEndTime = convertTo24HourFormat("10:00 PM");

  if (newStart === newEnd) {
    return "Start time and end time must be different";
  }

  if (newStart > newEnd) {
    return "Invalid time range: Start time must be before the end time";
  }

  if (
    newStart < scheduleStartTime ||
    newStart > scheduleEndTime ||
    newEnd < scheduleStartTime ||
    newEnd > scheduleEndTime
  ) {
    return "Please select a time between 06:00 AM and 10:00 PM";
  }

  for (const schedule of schedules) {
    const scheduleStart = convertTo24HourFormat(schedule.startTime);
    const scheduleEnd = convertTo24HourFormat(schedule.endTime);

    if (
      (newStart >= scheduleStart && newStart < scheduleEnd) ||
      (newEnd > scheduleStart && newEnd <= scheduleEnd) ||
      (newStart <= scheduleStart && newEnd >= scheduleEnd)
    ) {
      return `Overlap with schedule "${schedule.poojaName}" from ${schedule.startTime} to ${schedule.endTime}`;
    }
  }

  return null;
}
